import {
  delay
} from 'redux-saga';
import {
  put,
  call
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import axiosRaw from 'axios';
import * as actions from '../actions/index';

export function* logoutSaga(action) {
  yield call([
    sessionStorage, 'removeItem'
  ], 'token');
  // yield call([sessionStorage, "removeItem"], "expirationDate");
  yield call([
    sessionStorage, 'removeItem'
  ], 'user');
  yield put(actions.logoutSucceed());
}

export function* checkAuthTimeoutSaga(action) {
  // const expirationTime = yield sessionStorage.getItem("expirationTime");
  // const nowTime = Date.now();


  // let exp = expirationTime - nowTime
  // if (exp >= 1) {
  //   yield put(actions.authUserSaga());
  // }
}
export function* checkPinxtTimeoutSaga(action) {
  // const expirationTime = yield sessionStorage.getItem("expirationTime");
  // const nowTime = Date.now();


  // let exp = expirationTime - nowTime
  // if (exp >= 1) {
  //   yield put(actions.authUserSaga());
  // }
}
export function* startAppSaga(action) {
  // console.log('DOES START APP RUN',action)
  const userId = yield sessionStorage.getItem('userId');
  const divId = yield sessionStorage.getItem('divID');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const hosted = yield sessionStorage.getItem('hosted');
  const bToken = yield localStorage.getItem("access_token");
  const access_token = localStorage.getItem("access_token");
  const authCode = yield sessionStorage.getItem('authCode');
  const winServerUrl = yield sessionStorage.getItem('winServerUrl');
  const sessionToken = yield sessionStorage.getItem("sessionToken");
  const multiMac = yield sessionStorage.getItem('multiMac');
  const masterAcct = action.masterAcct;
  const multi = action.multi;
  const tm = yield sessionStorage.getItem('techMobile');
  const tenantAcct = action.tenantAcct;
  const pspPage = action.pspPage !== undefined ? action.pspPage : null;
  const tenantDetails = action.tenantDetails || null;
  const ur = yield sessionStorage.getItem('ur');
  // WIN-1611: Only send x-client-jwt when sessionToken is missing/invalid so decode middleware
  // can fall through to the x-client-jwt path. Avoids duplicate token exposure in headers.
  const hasValidSession = sessionToken && sessionToken !== 'null' && sessionToken.length > 30;
  let inst2Obj;
  if(hosted === true || hosted ==='true'){
    const headers = {
      'Authorization': 'Bearer '+ access_token,
      'sessiontoken': sessionToken
    };
    if (!hasValidSession) headers['x-client-jwt'] = access_token;
    inst2Obj = {
      withCredentials: true,
      baseURL: winServerUrl,
      headers
    }
  } else {
    let codee = authCode && authCode !=='null'?authCode:(sessionToken && sessionToken !== 'null' ? sessionToken: access_token)
    const headers = {
      'Authorization': 'Bearer '+ access_token,
      'Access-Control-Allow-Credentials':true,
      'sessiontoken': codee
    };
    if (!hasValidSession) headers['x-client-jwt'] = access_token;
    inst2Obj = {
      baseURL: winServerUrl,
      headers
    }
  }
  const instance2 = yield axiosRaw.create(inst2Obj);

  // const formBody ='bToken='+bToken+'&divId='+divId+'&userId='+userId+'&accountNumber='+accountNumber+'&hosted='+hosted;
  const body = {
    bToken:bToken,
    divId:divId,
    userId:userId,
    accountNumber:accountNumber,
    hosted:hosted,
    masterAcct:masterAcct,
    multi:multi,
    multiMac:multiMac,
    tm:tm,
    ur:ur,
    tenantAcct:tenantAcct,
    userRoles: yield sessionStorage.getItem('userRoles'),
    featureFlags:yield sessionStorage.getItem('featureFlags'),
    isSpectrumReady:yield sessionStorage.getItem('isSpectrumReady')
  }

  try {
    const startAppResponse = yield instance2.post(
      '/startApp',
      body
    ).then(res => {
        return res
    })
    
  // Store the new session data in a pending key instead of applying immediately.
  // This prevents sessionStorage corruption if the user cancels the browser reload dialog.
  // The pending data will be applied on the next page load in App.js (module-level IIFE).
  // A timestamp is included so stale pending data (older than 30 seconds) is discarded.
  const pendingData = {
    timestamp: Date.now(),
    pspPage: pspPage,
    tenantAddressLine1: tenantDetails ? tenantDetails.tenantAddressLine1 : null,
    tenantAddressLine2: tenantDetails ? tenantDetails.tenantAddressLine2 : null,
    authCode: null,
    divID: startAppResponse.data.data.divId,
    mac: startAppResponse.data.data.mac,
    vendorModel: startAppResponse.data.data.vendorModel,
    featureFlags: startAppResponse.data.data.featureFlags,
    type: startAppResponse.data.data.type,
    sessionToken: startAppResponse.data.data.sessionToken,
    masterAcct: masterAcct || startAppResponse.data.data.masterAcct,
    accountNumber: startAppResponse.data.data.accountNumber,
    subclass: startAppResponse.data.data.subclass || null
  };
  yield sessionStorage.setItem('pendingStartApp', JSON.stringify(pendingData));
  yield call([sessionStorage, 'removeItem'], 'startAppError');

  yield window.location.reload(false)
} catch (err) {
  const response = err?.response;
  const status = response?.status;
  const isTimeout = err?.code === 'ECONNABORTED' || err?.message?.includes('timeout');
  const errorCode = response?.data?.errorCode || null;

  // WIN-1611: Only clear session state for definitive auth/resource failures (401, 403, 404).
  // Transient errors (timeouts, 5xx) should not destroy the session — user can retry.
  const isDefinitiveFailure = status === 401 || status === 403 || status === 404;
  if (isDefinitiveFailure) {
    yield call([sessionStorage, 'removeItem'], 'sessionToken');
    yield call([sessionStorage, 'removeItem'], 'mac');
    yield call([sessionStorage, 'removeItem'], 'fullAuth');
    yield call([sessionStorage, 'removeItem'], 'pendingStartApp');
  }

  const errorPayload = {
    error: response?.data?.detail || response?.data?.error || err?.message || 'Unknown error',
    errorCode,
    message: isTimeout 
      ? `The server did not respond in time while loading account ${accountNumber || 'unknown'}` 
      : (response?.data?.message || 'Something went wrong'),
    accountNumber: response?.data?.accountNumber || accountNumber || null,
    mac: response?.data?.mac || null,
    upstreamUrl: response?.data?.upstreamUrl || (isTimeout ? winServerUrl + 'startApp' : null)
  };
  yield call([sessionStorage, 'setItem'], 'startAppError', JSON.stringify(errorPayload));
  yield put(actions.authFail(errorPayload));
}
}

export function* authTokenSaga(action) {
  const userId = yield sessionStorage.getItem('userId');
  const divId = yield sessionStorage.getItem('divID');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const hosted = yield sessionStorage.getItem('hosted');

  yield put(actions.authStart());
  const winServerUrl = action.winServerUrl;
  const authCode = action.authCode;
  const access_token = localStorage.getItem("access_token")
  // console.log('ACCCCCC', access_token)
  const winServerUrlStripped = winServerUrl.replace('winserver/', '')
  //COMMENT IN WHEN TESTING SERVER 
  // console.log('HOSTED', hosted)
  if(hosted === true || hosted === 'true'){
    const instance = axiosRaw.create({
      baseURL: winServerUrlStripped,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        
        // 'Authorization': 'Bearer '+ localStorage.getItem("access_token")
      }
    });
    const formBody ='client_id=winui-scp-scl&grant_type=authorization_code&scope=test&code='+ authCode;
    try {
      const tokenResponse = yield instance.post(
        '/auth/oauth/v2/token',
        formBody
      ).then(res => {
          return res
      })
      // console.log('ABOUT TO START APP')

      
    yield sessionStorage.setItem('refresh_token', tokenResponse.data.refresh_token);        
    yield sessionStorage.setItem('id_token', tokenResponse.data.id_token);     
    yield localStorage.setItem("access_token", tokenResponse.data.access_token);
    yield sessionStorage.setItem('token', null);
    yield sessionStorage.setItem('expirationTime', Date.now()+tokenResponse.data.expires_in);
  
    // console.log('ABOUT TO START APP')
    yield put(actions.startAppSaga());
    yield put(actions.authSuccess(tokenResponse.data.access_token));
    // window.location = 'http://localhost:3000';
  } catch ({
    error,
    response
  }) {
    yield put(actions.authFail({
      error: error,
      message: response.data.message
    }));
  }
  } else {
    // console.log('NOT HOSTED')
    yield sessionStorage.setItem('refresh_token', null);        
    yield sessionStorage.setItem('id_token', null);     
    yield sessionStorage.setItem('token', null);
    yield sessionStorage.setItem('expirationTime', Date.now()+1000000);
  
    // console.log('ABOUT TO START APP')
    yield put(actions.startAppSaga());
    yield put(actions.authSuccess(authCode));
  }


 
  // yield put(actions.authSuccess('FAKE TOKEN')); //COMMENT OUT WHEN TESTING SERVER
}
export function* authUserSaga(action) {
  // yield put(actions.authStart());


  //COMMENT IN WHEN TESTING SERVER 
  // try {
    // const response = yield axios.post('/auth');
    // console.log('what is response', response)
    // yield sessionStorage.setItem('token', response.data.token);
    // yield sessionStorage.setItem('authCode', null);
    // yield sessionStorage.setItem('expirationTime', Date.now());

    // yield put(actions.authSuccess(response.data.token));
    // window.location = 'http://localhost:3000';
  // } catch ({
  //   error,
  //   response
  // }) {
  //   yield put(actions.authFail({
  //     error: error,
  //     message: response.data.message
  //   }));
  // }

  // yield put(actions.authSuccess('FAKE TOKEN')); //COMMENT OUT WHEN TESTING SERVER
    yield put(actions.authSuccess(sessionStorage.getItem("sessionToken")));

}
export function* pinxtSaga(action) {
  yield put(actions.pinxtStart());

  try {
    const response = yield axios.post('/pinxt');
    yield sessionStorage.setItem('pToken', response.data.token);
    yield sessionStorage.setItem('expirationPinxt', Date.now());

    yield put(actions.authSuccess(response.data.token));
    window.location = 'http://localhost:3000';
    // window.location = 'http://kapamacp5zzg8wn.local:3000';//jeff
    // window.location = 'http://macltus66963.local:3000';//kiranmai
    // window.location = 'http://macltus66825.local:3000';//rubia


  } catch ({
    error,
    response
  }) {
    yield put(actions.authFail({
      error: error,
      message: response.data.message
    }));
  }

  // yield put(actions.authSuccess('FAKE TOKEN')); //COMMENT OUT WHEN TESTING SERVER
}

export function* authCheckStateSaga(action) {
  // console.log('DOES AUTH CHECK ', action)
  let authCode = action.authCode;
  let winServerUrl = action.winServerUrl;
  // console.log('authCode', authCode)
  const persistedError = yield call([sessionStorage, 'getItem'], 'startAppError');
  if (persistedError) {
    // WIN-1611: Keep startAppError in sessionStorage so repeated refreshes continue
    // showing the proper error instead of falling through to a generic "Something went wrong".
    // It will be cleared on a successful startApp.
    yield put(actions.authFail(JSON.parse(persistedError)));
    return;
  }

  if(authCode && authCode.length > 10){
    yield put(actions.authTokenSaga(authCode, winServerUrl))
  }else{
    const token = yield sessionStorage.getItem('token');
    const refresh_token = yield sessionStorage.getItem('refresh_token');
    const access_token = yield localStorage.getItem("access_token");
    const expirationTime = yield sessionStorage.getItem('expirationTime');
    const fullAuth = yield sessionStorage.getItem('fullAuth');
    const multiMac = yield sessionStorage.getItem('multiMac')
    if(access_token && access_token !== null && access_token !== 'null'){
      if(!fullAuth && ( multiMac && multiMac.length > 5)){
        console.log('STARTIINGG')
        yield put(actions.startAppSaga());
        yield sessionStorage.setItem('fullAuth', true);

      }
      yield put(actions.authSuccess(null));
    } else if (!token || token=== 'null' || !expirationTime || expirationTime === 'null') {
      
      yield sessionStorage.setItem('token', null);
      yield sessionStorage.setItem('expirationTime', null);
      yield put(actions.authUserSaga());
      // yield put(actions.logout());
    }else{
      const nowTime = Date.now();
  
      let exp = nowTime - expirationTime;
      // if (exp >= 900000) {
    
      //   // console.log("token has expired");
      //   yield sessionStorage.setItem('token', null);
      //   yield sessionStorage.setItem('expirationTime', null);
      //   yield put(actions.authUserSaga());
      //   yield put(actions.logout());
      // } else {
      //   yield put(actions.authSuccess(token));
      // }
      yield put(actions.authSuccess(token));
    }
    return
  
    

  }
  
  
}
export function* pinxtCheckStateSaga(action) {
  
  // console.log('pinxt check')
  const pToken = yield sessionStorage.getItem('pToken');
  const expirationPinxt = yield sessionStorage.getItem('expirationPinxt');

  if (!pToken || !expirationPinxt || expirationPinxt === 'null') {

    yield sessionStorage.setItem('pToken', null);
    yield sessionStorage.setItem('expirationPinxt', null);
    yield put(actions.pinxtSaga());
    // yield put(actions.logout());
    return;
  }

  const nowTime = Date.now();

  let exp = nowTime - expirationPinxt;
  // if (exp >= 900000) {

  //   // console.log("pToken has expired");
  //   yield sessionStorage.setItem('pToken', null);
  //   yield sessionStorage.setItem('expirationPinxt', null);
  //   yield put(actions.pinxtSaga());

  //   yield put(actions.logout());
  // } else {
  //   yield put(actions.authSuccess(pToken));
  // }
  yield put(actions.authSuccess(pToken));

}

